<mat-dialog-content class="dialog">
  <button mat-mini-fab class="dialog__close" [disableRipple]="true" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>

  <ng-container *ngTemplateOutlet="data.template; context: data.context"></ng-container>
</mat-dialog-content>
